import React, { useState, useEffect, useRef } from "react";
import "../CSS/WithdrawalDashboard.css";
import styles from '../CSS/AgentHome.module.css';

import { GoArrowRight } from "react-icons/go";

import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

import Loading from '../Components/Loading';
import Error from '../Components/Error';

const PendingDeposit = () => {
    const { fetchData, postData } = useAuth();

    const [loader, setLoader] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorText, setErrorText] = useState('');

    const [symbol, setSymbol] = useState('')
    const [withdrawals, setWithdrawals] = useState([])

    const navigate = useNavigate();

    const displayError = (message) => {
        setIsError(true);
        setErrorText(message);

        const timerId = setTimeout(() => {
            setIsError(false);
            setErrorText('');
        }, 1500);

        return () => clearTimeout(timerId);
    };

    const isFirstRun = useRef(true);
    async function getData() {
        setLoader(true);

        try {
            const data = await fetchData('/admin/pending/recharge');
            setLoader(false);

            setWithdrawals(data.records);
            setSymbol(data.symbol)
        } catch (error) {
            setLoader(false);
            displayError(error.message)
        }
    }

    useEffect(() => {
        if (isFirstRun.current) {
            getData();
            isFirstRun.current = false;
        }
    }, [])

    const handleFullScreen = (e) => {
        if (e.target.requestFullscreen) {
            e.target.requestFullscreen();
        }
    };


    async function payAction(action, amount, orderId) {
        setLoader(true);

        try {
            await postData('/admin/callback/recharge', { action, amount, orderId });
            setLoader(false);
            
            setWithdrawals(prevData => prevData.filter(item => item.orderId !== orderId));
        } catch (error) {
            setLoader(false);
            displayError(error.message)
        }
    }

    return (
        <div className="dashboard">
            {loader && <Loading />}
            {isError && <Error errorMsg={errorText} />}

            <div className={styles.topbar}>
                <div className={styles.left}>
                    <h1>Pending Deposits</h1>
                </div>

                <div className={styles.right} style={{
                    display: "flex",
                    alignItems: "center",
                }} onClick={() => navigate(-1)}>
                    <div>Go Back</div>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: 20
                    }}>
                        <GoArrowRight />
                    </div>
                </div>
            </div>

            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>User</th>
                            <th>Deposit Amount</th>
                            <th>Order ID</th>
                            <th>Proof</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {withdrawals.map((w, i) => {
                            const imageUrl = `data:${w.proof?.contentType};base64,${w.proof?.image}`;

                            return (
                                (
                                    <tr key={i}>
                                        <td>
                                            <div>{w.id}</div>
                                        </td>
                                        <td>
                                            <div>{w.convertedAmount} {symbol}</div>
                                            <div className="subtext">In USD: {w.amount}$</div>
                                        </td>
                                        <td>
                                            <div>{w.orderId}</div>
                                            <div className="subtext">{w.date}</div>
                                        </td>
                                        <td>
                                            <img src={imageUrl} onClick={handleFullScreen}  alt="" height={50} />
                                        </td>
                                        <td>
                                            <button className="btn approve" onClick={() => payAction('approve', w.convertedAmount, w.orderId)}>Approve</button>
                                            <button className="btn decline" onClick={() => payAction('reject', w.convertedAmount, w.orderId)}>Decline</button>
                                        </td>
                                    </tr>
                                )
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PendingDeposit;